<div class="status-chip" [class]="reasonCode?.secondaryType">
  {{ reasonCode?.label }}
</div>
